import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

export default new Vuetify({
    theme: {
        options: {
            customProperties: true,
            variations: false
        },
        themes: {
            light: {
                primary: "#004b6f",
                secondary: "#0074ac"
            }
        }
    }
})
